import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import type { IOfflineDataContextValue } from './types';

export default createContext<IOfflineDataContextValue>({
  state: initialState,
  actions: initialActionsState,
});
